
import {Options, Vue} from 'vue-class-component'
import Button from "primevue/button"
import {rpcClient} from "@/api/WebsocketClient"
import {Language, useGettext} from "@jshmrtn/vue3-gettext"
import {Router, useRouter} from "vue-router"
import {userServiceApi} from "@/api/UserServiceApi"
import AnimatedInput from "@/components/controls/AnimatedInput.vue"
import useToast from "@/util/toasts"
import {getErrorMessage} from "@/util/errorHandler"

@Options({
  name: "PasswordReset",
  components: {
    Button, AnimatedInput
  }
})
export default class PasswordReset extends Vue {

  i18n: Language = useGettext()
  router: Router = useRouter()
  rpcClient = rpcClient
  toast = useToast()

  newPassword: string = ''
  newPasswordRepeat: string = ''
  emailOrUserName: string = ''
  loading = false

  get token() {
    // Try to get token from query params first
    let token = this.$route.query?.token

    // Workaround: If token is null/empty, check if it's in the hash due to HTML entity encoding bug
    // This handles old emails that were sent before the backend fix
    if (!token && this.$route.hash) {
      // Hash format: #x3D;4c555f89-d428-4116-a27d-c2c02cfd0e5c
      const hashMatch = this.$route.hash.match(/#x3D;(.+)/)
      if (hashMatch) {
        token = hashMatch[1]
      }
    }

    return token
  }

  send() {
    if (this.token && this.newPassword) {
      if (this.newPassword !== this.newPasswordRepeat) {
        return
      }

      this.loading = true
      userServiceApi._changePassword(null, this.token, this.newPassword).then(() => {
        this.toast.success(this.i18n.$gettext('Passwort wurde erfolgreich geändert.'))
        this.$router.push('/')
      }).catch((error) => {
        console.error('Password reset failed:', error)
        this.toast.error(getErrorMessage(error, this.i18n.$gettext('Passwort konnte nicht geändert werden.')))
      }).finally(() => {
        this.loading = false
      })
    } else if (this.emailOrUserName) {
      this.loading = true
      userServiceApi._sendPasswordResetMail(this.emailOrUserName).finally(() => {
        this.loading = false
      })
    }
  }
}
